#import "./form-field-fragment.graphql"
#import "./page-rule-fragment.graphql"

fragment FormPageFragment on FormPage {
    id
    position
    fields {
        ...FormFieldFragment
    }
    defaultRule {
        ...PageRuleFragment
    }
    conditionalRules {
        ...PageRuleFragment
    }
}
